import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { User } from 'models/UserModel';


const UserList: React.FC = () => {
  const width = { name: 54, location: 20, role: 20 };
  const [formId, formName] = [Code.Form.Id.USER, Code.Form.Name.USER];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [userData, setUserData] = useState<User[]>([]); 
  const [selectedUser, setselectedUser] = useState<User | null>(null);
  
  const [roleId, setRoleId] = useState<number>(1);
  const [roleOptions, setRoleOptions] = Hooks.Form.Options();
  
  const triggers = [pno, rows, search, activeId, roleId];
  const Privilege = Hooks.Privilege.List(formId);

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.ROLE, Code.Option.Common.ALL, setRoleOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.User.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.User.Id, 
        Name.User.FullName, 
        Name.Location.Name, 
        Name.Role.Name
      ]),
      role_id: roleId,
    });
     
    await API.Data.List<User>(url, setUserData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Role} options={roleOptions} onChange={(value) => { setRoleId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, userData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.User, width.name],
                [Title.Location, width.location], 
                [Title.Role, width.role]
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(userData) && (
              <Control.Grid.Row>
                {userData.map((userData) => { const path = Utility.Join.Edit(Privilege, formName, userData.user_key); return (
                <Control.Grid.Data<User> key={userData.user_id} itemKey={userData.user_key} data={userData} setMenuPosition={setMenuPosition} setSelectedData={setselectedUser} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={userData.user_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={path} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link path={path} width={width.name} iframeRef={iframeRef} value={Utility.Get.FullName(userData,Code.Form.Name.USER)} />
                  <Control.Grid.Items values={[
                    [userData.location_name, width.location], 
                    [userData.role_name, width.role]
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={userData.user_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={userData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedUser?.user_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedUser?.user_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default UserList;